import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DestroySubscribers } from '../../../decorators/destroy-subscribers.decorator';
import { CheckboxConfig, PageSettings, StatusColorSchema, TableInterface } from '../../table-layout/table-layout.model';
import { IColumn, IRow, ITableData } from '../service-facade/data.response';
import { IOrderValues } from '../../../services/tables/interfaces/table.service.interface';

@Component({
  selector: 'gtd-table',
  templateUrl: './table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@DestroySubscribers()
export class TableComponent implements OnInit {
  @Input() key!: string;
  @Input() settings!: PageSettings;
  @Input() data!: ITableData | null;
  @Input() columns!: IColumn[];
  @Input() orderValues!: { [id: string]: 'asc' | 'desc' };
  @Input() rowActions?: TableInterface['rowActions'];
  @Input() checkboxesGroup?: CheckboxConfig['formGroup'];
  @Input() statusColorScheme: StatusColorSchema = {};
  @Input() statusHint: TableInterface['statusHint'];
  @Input() isLoading = true;
  @Input() stickyActions = false;
  @Input() disabledSortColumns: string[] = [];
  @Output() sort = new EventEmitter<IOrderValues>();

  public isAllChecked: boolean = false;
  public isIndeterminate: boolean = false;

  private subscribers: any = {};

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    if (this.rowActions) {
      this.rowActions = this.rowActions.filter((item) => item);
    }
    this.subscribers.checkboxesChange = this.checkboxesGroup?.valueChanges.subscribe((data) => {
      const countChecked = Object.values(data).filter(Boolean).length;
      this.isAllChecked = countChecked === (this.data?.limit ?? 25);
      this.isIndeterminate = countChecked > 0 && countChecked < (this.data?.limit ?? 25);
      this.cd.detectChanges();
    });
  }

  handleSort(column: IColumn): void {
    if (!column.disableOrder && !this.disabledSortColumns?.includes(column.id)) {
      this.sort.emit({ [column.id]: this.orderValues?.[column.id] === 'asc' ? 'desc' : 'asc' });
    }
  }

  getCellStatusHexColor(row: IRow): string {
    return this.statusColorScheme
      ? Object.entries(this.statusColorScheme)
          .filter(([, func]) => func(row))
          .map(([hexColor]) => hexColor)
          .join(' ')
      : '';
  }

  changeValueGroup(checked: boolean): void {
    for (const { id } of this.data?.rows || []) {
      this.checkboxesGroup?.controls[id]?.setValue(checked);
    }
  }

  getCheckBoxFormControl(row: IRow) {
    return this.checkboxesGroup?.controls[row['id']];
  }
}
